__turbopack_context__.v({
  "className": "noto_sans_fe5d5a4b-module__qkB4Vq__className",
  "variable": "noto_sans_fe5d5a4b-module__qkB4Vq__variable",
});
